export default {
  Model: {},
  Actions: {
    CREATE_NEW_AI_SUGGESTIONS_WORKSPACE_ITEMS_SUCCESS:
      'agenda_ai_suggestions/CREATE_NEW_AI_SUGGESTIONS_WORKSPACE_ITEMS_SUCCESS',
  },
  State: {},
};
